module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4gdD9"))).then(() => parcelRequire('2KbAe'));